import * as React from "react";

/**
 * Hides content visually while keeping it available to screen readers.
 * Used to satisfy Radix's required DialogTitle without showing a heading.
 */
export const VisuallyHidden = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ style, ...props }, ref) => (
  <span
    ref={ref}
    style={{
      position: "absolute",
      width: 1,
      height: 1,
      padding: 0,
      margin: -1,
      overflow: "hidden",
      clip: "rect(0, 0, 0, 0)",
      whiteSpace: "nowrap",
      borderWidth: 0,
      ...style,
    }}
    {...props}
  />
));
VisuallyHidden.displayName = "VisuallyHidden";
